import { useState, useEffect} from "react"
import Frame from '../stars/ratingStar'

const FeedBackFormLog = () => {

    const [parametros, setParametros] = useState(null)

    useEffect(() => {
        const fullToken = window.location.search?.split('&')[0]?.replace('?', '')

        if (!fullToken) {
            console.error("No se encontró el token en la URL")
            return
        }
        const apiURL = `${process.env.REACT_APP_API_TOKEN}/api/decodeToken/${fullToken}`
        fetch(apiURL)
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    console.error("Error al decodificar el token:", data.error)
                    return
                }
                setParametros(data)
            })
            .catch(err => console.error("Error en la petición:", err))
    }, [])

    const handlerSubmit = async ({ rating, comments }) => {
        if (!parametros) return console.warn("faltan parametros decodificados")
        const { idTicket, idBoard, columnIdCal, columnIdComent } = parametros

        try {
            console.log("enviando respuesta")
            let url = process.env.REACT_APP_URL
            let access_token = process.env.REACT_APP_ACCESS_TOKEN

            let query_clas = `mutation {change_multiple_column_values(item_id:${idTicket}, board_id:${idBoard}, column_values: "{\\"${columnIdCal}\\" : {\\"rating\\" : ${rating}}}") {id}}`

            let query_comments = `mutation {change_multiple_column_values(item_id:${idTicket}, board_id:${idBoard}, column_values: "{\\"${columnIdComent}\\" : \\"${comments}\\"}"){id}}`

            const response_score = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${access_token}`,
                    // 'API-Version': '2023-04'
                },
                body: JSON.stringify({ "query": query_clas })
            });
            if (response_score.ok) {
                const data = await response_score.json();
                console.log('Respuesta exitosa:', data);
                console.log("Score actualizado :)")
            } else {
                console.error('Error en la solicitud:', response_score.status, response_score.statusText);
                console.log(`Error al enviar el score: ${response_score.status}`)
            }

            const response_comments = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${access_token}`,
                    // 'API-Version': '2023-04'
                },
                body: JSON.stringify({ "query": query_comments })
            });
            if (response_comments.ok) {
                // Procesa el cuerpo de la respuesta como JSON
                const data = await response_comments.json();
                console.log('Respuesta exitosa:', data);
                // alert("Gracias por el comment");
                console.log("Comentario actualizado")
            } else {
                // Maneja el caso en el que la respuesta no sea exitosa
                console.error('Error en la solicitud:', response_comments.status, response_comments.statusText);
                console.log(`Error al enviar el comments: ${response_comments.status}`)
                const dataError = await response_comments.json().catch(() => null)
                console.log("Detalles del error: ", dataError)

            }

        } catch (err) {
            console.log('Error al enviar feedback:', err)

        }

    }

    return (
        <div>
            <Frame enviar={handlerSubmit}></Frame>

        </div>
    )

}

export default FeedBackFormLog


